import React from "react";
import { RCCIcon } from "react-common-components";
import Action from "../Action";

export function Handle() {
	return (
		<Action cursor="grab">
			<RCCIcon 
				name="dragIndicator"
				size={16}
			/>
		</Action>
	);
}

export default Handle;
